import React from 'react';
import footer_logo from '../../assets/img/footer_logo.svg';
import footer_logo_phone from '../../assets/img/footer_logo_phone.svg';
import telegram from '../../assets/img/social/telegram.svg';
import inst from '../../assets/img/social/inst.svg';
import face from '../../assets/img/social/face.svg';
import youtube from '../../assets/img/social/youtube.svg';
import {useSelector} from 'react-redux';
import {RootState} from '../../redux/store';
import {useTranslation} from 'react-i18next';
import styles from './Footer.module.css';
import FooterMenuSection from './FooterMenuSection';
import FooterMenuItem from './FooterMenuItem';
import FooterMenuList from './FooterMenuList';

interface InformationItem {
	href: string;
	title: string;
	sort_order: string | number;
}

interface BlogCategory {
	href: string;
	name: string;
}

interface Category {
	href: string;
	name: string;
	meta_data?: {
		bottom?: string | number;
	};
}

interface AppData {
	home?: string;
	contact?: string;
	button_contact?: string;
	account_link?: string;
	text_account?: string;
	text_information?: string;
	config_name?: string;
	catalog?: string;
	text_catalog?: string;
	text_powered?: string;
	informations?: InformationItem[];
	top_blog?: BlogCategory[];
	categories?: Category[];
	telegram_url?: string;
	instagram_url?: string;
	facebook_url?: string;
	instagram2_url?: string;
	youtube_url?: string;
}

const Footer = () => {
	const {t} = useTranslation();
	const apiData = useSelector(
		(state: RootState) => state.appData.appData,
	) as AppData | null;

	if (!apiData) {
		return null;
	}

	return (
		<footer className={styles.footer}>
			<div className="container">
				<div className={styles.footer__row}>
					<div className={styles.footer__column}>
						{apiData.home && (
							<>
								<a href={apiData.home} className={styles.footer__logo}>
									<img src={footer_logo} alt="footer__logo" />
								</a>
								<a href={apiData.home} className={styles.footer__logophone}>
									<img src={footer_logo_phone} alt="footer__logo" />
								</a>
							</>
						)}
					</div>
					<div className={styles.footer__column}>
						<FooterMenuSection
							title={apiData.config_name}
							customItems={
								<>
									{apiData.informations && (
										<FooterMenuList items={apiData.informations} />
									)}
									{apiData.contact && (
										<FooterMenuItem href={apiData.contact}>
											{t('Контакти')}
										</FooterMenuItem>
									)}
									{apiData.account_link && (
										<FooterMenuItem href={apiData.account_link}>
											{apiData.text_account}
										</FooterMenuItem>
									)}
								</>
							}
						/>
					</div>
					<div className={styles.footer__column}>
						<FooterMenuSection
							title={t('Інформація')}
							customItems={
								<>
									{apiData.catalog && (
										<FooterMenuItem href={apiData.catalog}>
											{t('Каталог')}
										</FooterMenuItem>
									)}
									{apiData.top_blog && apiData.top_blog[0] && (
										<FooterMenuItem href={apiData.top_blog[0].href}>
											{apiData.top_blog[0].name}
										</FooterMenuItem>
									)}
									{apiData.top_blog
										?.filter((_, index) => index > 0)
										.map((top_blog_cat) => (
											<FooterMenuItem
												key={top_blog_cat.href}
												href={top_blog_cat.href}
											>
												{top_blog_cat.name}
											</FooterMenuItem>
										))}
									{apiData.informations
										?.filter(
											(information) =>
												information &&
												parseInt(String(information.sort_order)) > 0,
										)
										.map((information) => (
											<FooterMenuItem
												key={information.href}
												href={information.href}
											>
												{information.title}
											</FooterMenuItem>
										))}
									{apiData.categories
										?.filter(
											(category) =>
												category?.meta_data &&
												parseInt(String(category.meta_data.bottom)) === 1,
										)
										.map((category, index) => (
											<FooterMenuItem key={index} href={category.href}>
												{category.name}
											</FooterMenuItem>
										))}
								</>
							}
						/>
					</div>
					<div className={styles.footer__column}>
						<div className={styles.socialFooter}>
							{apiData.telegram_url && (
								<a
									href={apiData.telegram_url}
									target="_blank"
									rel="noreferrer"
									className={styles.socialFooter__link}
								>
									<img src={telegram} alt="telegram" />
								</a>
							)}
							{apiData.instagram_url && (
								<a
									href={apiData.instagram_url}
									target="_blank"
									rel="noreferrer"
									className={styles.socialFooter__link}
								>
									<img src={inst} alt="instagram" />
								</a>
							)}
							{apiData.facebook_url && (
								<a
									href={apiData.facebook_url}
									target="_blank"
									rel="noreferrer"
									className={styles.socialFooter__link}
								>
									<img src={face} alt="facebook" />
								</a>
							)}
							{apiData.instagram2_url && (
								<a
									href={apiData.instagram2_url}
									target="_blank"
									rel="noreferrer"
									className={styles.socialFooter__link}
								>
									<img src={inst} alt="instagram" />
								</a>
							)}
							{apiData.youtube_url && (
								<a
									href={apiData.youtube_url}
									target="_blank"
									rel="noreferrer"
									className={styles.socialFooter__link}
								>
									<img src={youtube} alt="YouTube" />
								</a>
							)}
						</div>
					</div>
				</div>
			</div>
			{apiData.text_powered && (
				<div className={styles.footer__policy}>{apiData.text_powered}</div>
			)}
		</footer>
	);
};

export default Footer;
